module.exports = __webpack_public_path__ + "media/images/landing/bg/team-9fa9d7b12d3e53c2d15b7af55a2ceb5b.jpg";